import { useState, useEffect } from 'react'
import apiFetch from '../utils/apiFetch.js'

export default function useAdminRole() {
    const [role, setRole] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const token = localStorage.getItem('token')
        if (!token) {
            setRole(null)
            setLoading(false)
            return
        }

        apiFetch('/api/auth/me')
            .then((res) => {
                if (!res.ok) throw new Error('Failed to fetch user')
                return res.json()
            })
            .then((data) => {
                setRole(data.role || null)
            })
            .catch((err) => {
                console.error('Failed to fetch role from /auth/me:', err)
                setRole(null)
            })
            .finally(() => {
                setLoading(false)
            })
    }, [])

    return { role, loading }
}
